import type { IconSvgObject } from './types';

const ShoppingBasketCheckIn01Icon: IconSvgObject = [
  ["path", { d: "M14 22H10C6.70017 22 5.05025 22 4.02513 20.9749C3 19.9497 3 18.2998 3 15V11C3 9.11438 3 8.17157 3.58579 7.58579C4.17157 7 5.11438 7 7 7H15C16.8856 7 17.8284 7 18.4142 7.58579C19 8.17157 19 9.11438 19 11V12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 9.5C15 5.63401 13.2091 2 11 2C8.79086 2 7 5.63401 7 9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M21 18C21 18 18.7905 15 18 15C17.2094 15 15 18 15 18M18 15.5V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ShoppingBasketCheckIn01Icon;
